import { z } from 'zod';
import { SearchSchema } from '@anytag/shared-validations';
import { InstagramFeedPostSortField } from '@anytag/graphql';
import { defaultProfilePostsFilterSchema } from '@anytag/shared-organisms';

export const AnalyticsIgMentionedPostsSearchSchema = SearchSchema.create({
  filter: defaultProfilePostsFilterSchema,
  sort: { field: InstagramFeedPostSortField }
});

export type AnalyticsIgMentionedPostsSearchSchemaType = z.infer<typeof AnalyticsIgMentionedPostsSearchSchema>;
